export default "__VITE_ASSET__BXB94_Qv__"